import { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './services.css';

const services = [
  {
    title: 'Website Design & Development',
    desc: 'Create high-converting, mobile-responsive websites designed to attract, engage, and convert visitors into leads with optimized UI/UX and fast performance.',
    side: 'right',
  },
  {
    title: 'Social Media Marketing',
    desc: 'Build a strong online presence with strategic content, consistent posting, and engagement-driven campaigns across platforms like Instagram, Facebook & LinkedIn.',
    side: 'left',
  },
  {
    title: 'Performance Marketing',
    desc: 'Drive measurable results with ROI-focused campaigns using Meta Ads and Google Ads to generate quality leads, increase conversions, and scale your business faster.',
    side: 'right',
  },
  {
    title: 'LinkedIn Personal Branding',
    desc: 'Position yourself as an industry authority with professional profile optimization, content strategy, and personal branding that attracts opportunities and builds trust.',
    side: 'left',
  },
  {
    title: 'Graphic Designing & Video Editing',
    desc: 'Stand out with visually compelling creatives and high-quality videos that capture attention, communicate your brand message, and boost engagement.',
    side: 'right',
  },
  {
    title: 'Search Engine Optimization (SEO)',
    desc: 'Improve your website’s visibility on Google with on-page, off-page, and technical SEO strategies that drive organic traffic and long-term business growth.',
    side: 'left',
  },
  {
    title: 'Content Writing',
    desc: 'Create compelling, SEO-optimized content that engages your audience, builds brand authority, and drives traffic through blogs, website copy, and marketing content tailored to your business goals.',
    side: 'right',
  },
  {
    title: 'Product Photography',
    desc: 'Showcase your products with professional, high-quality visuals that enhance brand perception and increase conversions across websites and social media.',
    side: 'left',
  },
];

export const Services = () => {
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = itemRefs.current.map((el) => {
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('visible');
          } else {
            el.classList.remove('visible');
          }
        },
        { threshold: 0.25 }
      );
      obs.observe(el);
      return obs;
    });

    return () => observers.forEach((o) => o && o.disconnect());
  }, []);

  return (
    <section className="services-section">
      <Container>
        {/* Header */}
        <Row className="justify-content-center text-center mb-5">
          <Col xs={12} md={8}>
            <p className="services-eyebrow">What We Offer</p>
            <h2 className="services-heading">Our Services</h2>
            <p className="services-subtext">
              From strategy to execution, we deliver end-to-end digital solutions
              that help businesses grow, engage, and convert in today's competitive landscape.
            </p>
          </Col>
        </Row>

        {/* Timeline */}
        <div className="timeline">
          <div className="timeline-line" />

          {services.map((s, i) => (
            <div
              key={i}
              className={`timeline-item ${s.side} `}
              ref={(el) => (itemRefs.current[i] = el)}
            >
              {/* Dot on the center line */}
              <div className="timeline-dot" />

              {/* Content card */}
              <div className={`timeline-card ${s.side}`}>
                <h5 className="timeline-title">{s.title}</h5>
                <p className="timeline-desc">{s.desc}</p>
              </div>


            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};
